













import { defineComponent, PropType } from '@vue/composition-api';


export default defineComponent({
  props: {
    variant: {
      type: String as PropType<string>,
      requier: false,
      default: "secondary",
    },
    href: {
      type: String as PropType<string>,
      requier: false,
      default: null,
    },
    target: {
      type: String as PropType<string>,
      requier: false,
      default: null,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      requier: false,
      default: false,
    },
  },
  setup (props, context) {

    const onClick = (event: Event) => {
      context.emit("click", event);
    }

    const onMousedown = (event: Event) => {
      context.emit("mousedown", event);
    }

    const onTouchstart = (event: Event) => {
      context.emit("touchstart", event);
    }

    return {
      onClick,
      onMousedown,
      onTouchstart,
    }
  }
});
